<template>
    <div
        class="c-o-request-section c-o-request-section--interested-companies no-print"
    >
        <modal
            class="c-m-modal--small"
            v-if="abortContractConfirmation"
            @close="abortContractConfirmation = false"
        >
            <abort-confirmation
                @close="abortContractConfirmation = false"
                @confirmedAbort="abortContract()"
            />
        </modal>
        <contract-status
            v-if="contractRequested && currentCompany()"
            @abort="abortContractConfirmation = true"
            :company="currentCompany()"
        />
        <div
            class="c-o-request-section__inner c-o-request-section__inner--centered"
        >
            <div
                class="c-o-request-section__main c-o-request-section__main--large"
            >
                <h2 class="c-o-request-section__title h2">
                    Företag som besvarat din förfrågan
                </h2>
                <p v-if="text" class="info-text">{{ text }}</p>
                <interested-companies-table
                    :companies="companies"
                ></interested-companies-table>
            </div>
        </div>
    </div>
</template>
<script>
import ContractStatus from "../../molecules/MoleculeContractStatus.vue";
import Modal from "../../molecules/MoleculeModal";
import InterestedCompaniesTable from "../OrganismInterestedCompaniesTable.vue";

import { mapActions, mapGetters } from "vuex";

import AbortConfirmation from "../../atoms/AtomAbortContractConfirmation.vue";

import {
    ABORT_CONTRACT_REQUEST,
    GET_CONTRACT,
    GET_IS_CONTRACT_REQUESTED
} from "../../../../store/store-models/contract-model";

export default {
    props: ["companies", "text"],
    data() {
        return {
            abortContractConfirmation: false
        };
    },
    components: {
        InterestedCompaniesTable,
        ContractStatus,
        Modal,
        AbortConfirmation
    },
    computed: {
        ...mapGetters({
            contractRequested: GET_IS_CONTRACT_REQUESTED,
            contract: GET_CONTRACT
        })
    },
    methods: {
        ...mapActions({
            postAbortContract: ABORT_CONTRACT_REQUEST
        }),
        abortContract() {
            this.postAbortContract(this.contractId);
            this.abortContractConfirmation = false;
        },
        currentCompany() {
            let tmpCompany = null;
            if (!this.contract) return tmpCompany;

            for (let i = 0; i < this.companies.length; i++) {
                if (this.companies[i].ContactId === this.contract.ContractorId)
                    tmpCompany = this.companies[i];
            }
            return tmpCompany;
        }
    }
};
</script>

<style scoped>
.info-text {
    font-size: 1.1rem;
    padding-right: 22rem;
}
@media screen and (max-width: 1024px) {
    .info-text {
        padding-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismRequestSectionInterestedCompanies.vue